import React from "react";

export const Button = ({ children, className, size = "md", variant = "solid", ...props }) => {
  const baseClasses = "rounded-full font-semibold transition-all shadow-md";

  const sizeClasses = {
    sm: "px-4 py-2 text-sm",
    md: "px-6 py-3 text-md",
    lg: "px-8 py-4 text-lg",
  };

  const variantClasses = {
    solid: "bg-rose-400 hover:bg-rose-500 text-white",
    outline: "border-2 border-gray-300 text-gray-700 hover:bg-gray-100",
  };

  return (
    <button
      className={`${baseClasses} ${sizeClasses[size]} ${variantClasses[variant]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};
